<template>
  <div ref="root" class="select-wrapper">
    <div class="t-select-group">
      <slot />
    </div>
  </div>
</template>

<style lang="less">
@import '~@npm/@gd/common-styles/lib/color-vars';
@import '~@npm/@gd/common-styles/dist/input';
@import '~@npm/@gd/common-styles/dist/select';

.select-wrapper {
  margin-right: 1em;
  &:last-child {
    margin-right: 0;
  }
  .t-select-group {
    .select();
  }
}
</style>
